var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoMapidNoOutline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1660.1,
    height: 360.49,
    viewBox: "0 0 1660.1 360.49",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\r\n        fill: #a1cc63;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #408bc9;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: #1366ae;\r\n      }"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(62.45 10.209)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    transform: "translate(35.015,35.015)",
    points: "471.28 258.31 470.67 121.54 402.46 232.44 369.43 232.43 301.53 126.1 301.85 258.31 277.12 258.31 221.43 0.42 294.58 0.44 386.95 148.92 477.27 0.44 538.6 0.44 539.46 258.31",
    style: {
      paintOrder: "stroke markers fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m786.78 35.435h-73.55l-116.12 257.87h75.91l20.59-50.33h111.64l20.82 50.32 77.44 0.05zm-71.16 153.96 33.78-81.89 33.8 81.88h-67.58z",
    style: {
      paintOrder: "stroke markers fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1163.2 130.62c0.78-60.19-52.12-95.61-107.99-95.61h-129.97v257.9l74.44-0.03-0.29-66.5 62.86-1.02c61.66-4.69 102.7-44.93 100.94-94.75zm-76.8 0.33c0.42 21.03-11.52 34.38-36.88 36.79l-49.84 0.41-0.37-75.19 46.27 0.06c5.19 0.01 10.63 0.94 15.55 2.58 0 0 25.49 6.27 25.27 35.35z",
    style: {
      paintOrder: "stroke markers fill"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1198,
    y: 35.435,
    width: 75.28,
    height: 257.9,
    style: {
      paintOrder: "stroke markers fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1597.6 167v-4.71c0.53-67.57-49.13-118.73-126.86-126.86h-145.35v257.9l132.46-0.5c19.2-0.07 37.9-3.28 55.97-9.77 51.51-18.5 85.04-62.14 83.79-116.07zm-97.95 51.2c-4.64 4.13-10.36 7.48-16.12 10.02-3.64 1.6-6.93 2.73-10.33 3.64-7.29 1.97-14.82 2.9-22.38 2.93l-50.64 0.23v-141.24h55.33c17.06 1.17 26.75 5.79 33.96 9.94 20.3 11.66 32.69 32.23 32.52 59.54v2.58c0.42 22.15-8.43 39.98-22.34 52.36z",
    style: {
      paintOrder: "stroke markers fill"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3972 0 0 1.3972 -6.0291 -471.04)",
    style: {
      strokeWidth: 0.71573
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    transform: "translate(-40.382 329.42)",
    points: "0 161.48 201.68 0.41 236.48 162.09 147.5 161.86",
    style: {
      paintOrder: "stroke markers fill"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    transform: "translate(-40.382 329.42)",
    points: "193.38 233.41 147.5 161.86 0 161.48",
    style: {
      paintOrder: "stroke markers fill"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    transform: "translate(-40.382 329.42)",
    points: "147.5 161.86 236.48 162.09 257.63 258.42 193.38 233.41",
    style: {
      paintOrder: "stroke markers fill"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMapidNoOutline);
export default __webpack_public_path__ + "static/media/logo_mapid_no_outline.75a614a1feba9f71b508fc1cdfeb7ec8.svg";
export { ForwardRef as ReactComponent };